import { createSelector } from 'reselect';
const selectVentures = (state: any) => state.ventures;


export const selectVenturesCurrentItem = createSelector([selectVentures], (ventures) => ventures.current);

export const selectVenturesListItems = createSelector([selectVentures], (ventures) => ventures.list);

export const selectVenturesQueryItems = createSelector([selectVentures], (ventures) => ventures.query);
export const selectVenturesItemById = (itemId: any) =>
    createSelector(selectVenturesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectVenturesCreatedItem = createSelector([selectVentures], (ventures) => ventures.create);

export const selectVenturesUpdatedItem = createSelector([selectVentures], (ventures) => ventures.update);

export const selectVenturesReadItem = createSelector([selectVentures], (ventures) => ventures.read);

export const selectVenturesDeletedItem = createSelector([selectVentures], (ventures) => ventures.delete);

export const selectVenturesSearchedItems = createSelector([selectVentures], (ventures) => ventures.search);

export const selectVenturesItemsCount = createSelector([selectVentures], (ventures) => ventures.count);

export const selectVenturesItemsFilter = createSelector([selectVentures], (ventures) => ventures.filter);